import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

import { useBilling } from '@/components/Billing/Billing.composables';
import BillingService from '@/components/Billing/billing-service';
import { FeatureTypes, ServiceActionRestrictionTypes } from '@/components/Billing/billing-types';
import AppActionService from '@/utils/AppActionService';
import WorkflowService from '@/utils/WorkflowService';
import { capitalizeWord } from '@/utils/language-service';


export default /*#__PURE__*/_defineComponent({
  __name: 'ActionUpgradeRequiredMenu',
  props: {
	workflow: { type: Object, required: true },
	action: { type: Object, required: true },
},
  setup(__props) {

const props = __props

const { usePlanById, useUpNextRequiredPlanToUse, useHasCapability } = useBilling();
const upNextRequiredPlanToUse = useUpNextRequiredPlanToUse();
const planById = usePlanById();
const hasCapability = useHasCapability();



const restrictedCustomerFeatureMap = {
	[ServiceActionRestrictionTypes.CustomCode]: FeatureTypes.CustomerCustomCodeActions,
	[ServiceActionRestrictionTypes.OutgoingApis]: FeatureTypes.CustomerOutgoingApiActions,
	[ServiceActionRestrictionTypes.MiniApps]: FeatureTypes.CustomerMiniApps,
	[ServiceActionRestrictionTypes.RedirectUrl]: FeatureTypes.CustomerRedirect,
	[ServiceActionRestrictionTypes.ExtraPremium]: FeatureTypes.CustomerExtraPremiumApps,
};

const restrictedNonCustomerFeatureMap = {
	[ServiceActionRestrictionTypes.CustomCode]: FeatureTypes.TeamCustomCodeActions,
	[ServiceActionRestrictionTypes.OutgoingApis]: FeatureTypes.TeamOutgoingApiActions,
};

const restrictedFeature = computed(() => {
	if (AppActionService.isActionOfSubFlow(props.action) && !hasCapability.value(FeatureTypes.SubFlows)) {
		return FeatureTypes.SubFlows;
	}
	if (isCustomerFacingFeature.value) {
		for (const [restrictionType, featureType] of Object.entries(restrictedCustomerFeatureMap)) {
			if (AppActionService.isActionRestrictedBy(props.action, restrictionType) && !hasCapability.value(featureType)) {
				return featureType;
			}
		}
	} else {
		for (const [restrictionType, featureType] of Object.entries(restrictedNonCustomerFeatureMap)) {
			if (AppActionService.isActionRestrictedBy(props.action, restrictionType) && !hasCapability.value(featureType)) {
				return featureType;
			}
		}
	}
	return null;
});

const minimalPlanIdToUse = computed(() => {
	if (restrictedFeature.value) {
		return upNextRequiredPlanToUse.value(restrictedFeature.value);
	}
	return null;
});

const minimalPlanToUse = computed(() => (minimalPlanIdToUse.value ? planById.value(minimalPlanIdToUse.value) : null));
const minimalPlanNameToUse = computed(() =>
	minimalPlanToUse.value ? capitalizeWord(BillingService.getPlanGroup(minimalPlanToUse.value)) : ''
);

const isCustomerFacingFeature = computed(() => WorkflowService.isCustomerFacingFeature(props.workflow));

return { __sfc: true,usePlanById, useUpNextRequiredPlanToUse, useHasCapability, upNextRequiredPlanToUse, planById, hasCapability, props, restrictedCustomerFeatureMap, restrictedNonCustomerFeatureMap, restrictedFeature, minimalPlanIdToUse, minimalPlanToUse, minimalPlanNameToUse, isCustomerFacingFeature }
}

})